export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-v1-960-c366da102304a19e53e20ef7f0c340af.png";